// Small shared pieces used across pages.
const COLORS = ['#3b82f6', '#8b5cf6', '#06b6d4', '#10b981', '#f59e0b', '#ef4444', '#ec4899', '#14b8a6'];

export const initials = (name) => name.split(' ').slice(0, 2).map((w) => w[0]).join('');
export const avatarColor = (key) => COLORS[[...String(key)].reduce((s, c) => s + c.charCodeAt(0), 0) % COLORS.length];

export const fmtPKR = (n) =>
  'PKR ' + Number(n).toLocaleString('en-PK', { maximumFractionDigits: 0 });

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];

export function Avatar({ name, id, size = 32 }) {
  return (
    <div className="avatar" style={{ background: avatarColor(id ?? name), width: size, height: size }}>
      {initials(name)}
    </div>
  );
}

export function Badge({ kind, children }) {
  return <span className={`badge badge-${kind.toLowerCase().replace(/_/g, '-')}`}>{children}</span>;
}

// For open-ended, user-created categories (department/employment-type names)
// where a fixed CSS class per value isn't possible — colors via the same
// hash used for avatars, so it stays consistent for a given name.
export function DynamicBadge({ label }) {
  const color = avatarColor(label);
  return <span className="badge" style={{ background: color + '22', color }}>{label}</span>;
}

export function Modal({ open, onClose, title, children, wide }) {
  if (!open) return null;
  return (
    <div className="modal-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={wide ? { maxWidth: 900 } : undefined}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function ErrorNote({ error }) {
  if (!error) return null;
  return <div className="error-note">{error}</div>;
}
